import { get, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Image from 'components/Image';
import { breakpoints, mediumUp } from 'constants/mediaQueries';

const IMAGE_WIDTH_MOBILE_PORTRAIT = 168;
const IMAGE_HEIGHT_MOBILE_PORTRAIT = 294;
const IMAGE_WIDTH_DESKTOP_PORTRAIT = 264;
const IMAGE_WIDTH_LANDSCAPE = 264 * 2 + 24;

const Background = ({ image, isPortrait, isLandscape, backgroundColor }) => (
  <div className="StoryCard__background">
    {isLandscape && (
      <div className="StoryCard__background-image-container">
        {!isEmpty(image) ? (
          <Image
            src={get(image, ['src'])}
            alt=""
            className="StoryCard__background-image"
            breakpoints={{
              [breakpoints.small.min]: IMAGE_WIDTH_LANDSCAPE,
            }}
          />
        ) : (
          <div className="StoryCard__background--blank" />
        )}
      </div>
    )}
    {isPortrait && (
      <div className="background--desktop">
        <div className="StoryCard__background-image-container">
          {!isEmpty(image) ? (
            <Image
              src={get(image, ['src'])}
              alt=""
              className="StoryCard__background-image"
              breakpoints={{
                [breakpoints.small.min]: IMAGE_WIDTH_DESKTOP_PORTRAIT,
              }}
            />
          ) : (
            <div className="StoryCard__background--blank" />
          )}
        </div>
      </div>
    )}
    {isPortrait && (
      <div className="background--mobile">
        <div className="StoryCard__background-image-container">
          {!isEmpty(image) ? (
            <Image
              src={get(image, ['src'])}
              alt=""
              className="StoryCard__background-image"
              breakpoints={{
                [breakpoints.small.min]: IMAGE_WIDTH_MOBILE_PORTRAIT,
              }}
              transformations={{
                crop: 'fill',
                aspectRatio: IMAGE_WIDTH_MOBILE_PORTRAIT / IMAGE_HEIGHT_MOBILE_PORTRAIT,
                gravity: 'center',
              }}
            />
          ) : (
            <div className="StoryCard__background--blank" />
          )}
        </div>
      </div>
    )}
    <style jsx>
      {`
        .StoryCard__background--blank {
          width: 100%;
          height: 100%;
          background-color: ${backgroundColor};
        }

        .StoryCard__background {
          width: 100%;
          height: 100%;
        }

        .StoryCard__background-image-container {
          width: 100%;
          height: 100%;
        }

        .background--desktop {
          height: 100%;
          display: none;
        }

        .background--mobile {
          height: 100%;
        }

        @media ${mediumUp} {
          .background--mobile {
            display: none;
          }
          .background--desktop {
            display: block;
          }
        }
      `}
    </style>
    <style jsx global>
      {`
        .StoryCard__background-image {
          object-fit: cover;
          object-position: center;
          height: 100%;
          width: 100%;
        }
      `}
    </style>
  </div>
);

Background.propTypes = {
  image: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string,
  }).isRequired,
  isPortrait: PropTypes.bool.isRequired,
  isLandscape: PropTypes.bool.isRequired,
  backgroundColor: PropTypes.string.isRequired,
};

export default Background;
